import "desvg";
import components from "@/js/components";
import pages from "@/js/pages";
import forms from "@/js/forms";

window.addEventListener("DOMContentLoaded", async () => {
    deSVG("img[inline]", true);
    components();
    pages();
    forms();
});
